<template>
	<div>
		<vue-date-picker mode="date" v-model="inputValue">
			<template v-slot="{ inputValue, inputEvents }">
					<div class="input-group">
						<input
								class="form-control"
								:value="inputValue"
								v-on="inputEvents"
								:placeholder="placeholder"
								:required="required"
						/>
						<span class="input-group-addon">
							<img src="/dist/site/static/icons/date_picker.svg" class="date picker" alt="Date picker">		
						</span>
					</div>
			</template>
		</vue-date-picker>
	</div>
</template>

<script>
	import VueDatePicker from 'v-calendar/lib/components/date-picker.umd'

	export default {
		name: 'DatePicker',

		components: {
			VueDatePicker
		},

		props: {
			value: String,
			placeholder: {
				type: String,
				default: 'Date'
			},
			required: Boolean,
		},

		beforeMount() {
			this.inputValue = this.value
		},

		data: () => {
			return {
				isActive: false,
				inputValue: null,
			}
		},

		methods: {
			toggle() {
				this.isActive = !this.isActive
			},
		},

		computed: {},

		watch: {
			inputValue(to, from) {
				this.$emit('input', to.toLocaleString())
			}
		}


	}
</script>

<style scoped>

</style>